// Configuration global de cores do sistema
// Estas cores podem ser alteradas para personalização do tema
// Este arquivo mantém compatibilidade com componentes que importam colors diretamente
// Para usar o tema dinâmico, use useThemeColors hook ou AppContext

import { DEFAULT_THEME_KEY, getTheme } from './themes';

// Get initial colors from default theme
const defaultTheme = getTheme(DEFAULT_THEME_KEY);

export const colors = {
  // Cores principais
  primary: defaultTheme.colors.primary,
  secondary: defaultTheme.colors.secondary,
  
  // Cores de fundo
  background: {
    default: defaultTheme.colors.background.default,
    paper: defaultTheme.colors.background.paper,
  },
  
  // Cores de texto
  text: {
    primary: defaultTheme.colors.text.primary,
    secondary: defaultTheme.colors.text.secondary,
  },
  
  // Cores de bordas
  border: {
    primary: defaultTheme.colors.border?.primary || `rgba(${hexToRgb(defaultTheme.colors.primary)}, 0.2)`,
    hover: defaultTheme.colors.border?.hover || `rgba(${hexToRgb(defaultTheme.colors.primary)}, 0.5)`,
    focus: defaultTheme.colors.border?.focus || defaultTheme.colors.primary,
  },
  
  // Cores de hover/efeitos
  hover: {
    light: defaultTheme.colors.hover.light,
    medium: defaultTheme.colors.hover.medium,
  },
  
  // Cores de progresso
  progress: {
    background: defaultTheme.colors.progress.background,
    fill: defaultTheme.colors.progress.fill,
  },
  
  // Cores de gradiente (para palanque)
  gradient: {
    top: defaultTheme.colors.gradient.top,
    bottom: defaultTheme.colors.gradient.bottom,
  },
};

// Helper function to convert hex to rgb
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : '218, 165, 32';
}

// Função para atualizar as cores baseado em um tema
export const updateColors = (themeKey) => {
  const theme = getTheme(themeKey);
  colors.primary = theme.colors.primary;
  colors.secondary = theme.colors.secondary;
  colors.background.default = theme.colors.background.default;
  colors.background.paper = theme.colors.background.paper;
  colors.text.primary = theme.colors.text.primary;
  colors.text.secondary = theme.colors.text.secondary;
  colors.border.primary = theme.colors.border?.primary || `rgba(${hexToRgb(theme.colors.primary)}, 0.2)`;
  colors.border.hover = theme.colors.border?.hover || `rgba(${hexToRgb(theme.colors.primary)}, 0.5)`;
  colors.border.focus = theme.colors.border?.focus || theme.colors.primary;
  colors.hover.light = theme.colors.hover.light;
  colors.hover.medium = theme.colors.hover.medium;
  colors.progress.background = theme.colors.progress.background;
  colors.progress.fill = theme.colors.progress.fill;
  colors.gradient.top = theme.colors.gradient.top;
  colors.gradient.bottom = theme.colors.gradient.bottom;
  return colors;
};

// Função para obter todas as cores
export const getColors = () => {
  return { ...colors };
};

